import * as GlobeActions from '~app/actions/globe';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  mode: '3D',
};

function morphGlobeRequested(state, {morphPromise, morphResolver}) {
  return {
    ...state,
    morphPromise,
    morphResolver,
  };
}

function morphGlobeFinished(state, {mode}) {
  const {morphPromise, morphResolver, ...restState} = state;
  return {
    ...restState,
    mode,
  };
}

function flyToRequested(state, {flyToPromise, flyToResolver, flyToLocation, flyToDuration}) {
  return {
    ...state,
    flyToPromise,
    flyToResolver,
    flyToLocation,
    flyToDuration,
  };
}

function flyToFinished(state) {
  const {flyToPromise, flyToResolver, flyToLocation, flyToDuration, ...restState} = state;
  return {
    ...restState,
  };
}

const ACTION_HANDLERS = {
  [GlobeActions.MORPH_GLOBE_REQUEST]: morphGlobeRequested,
  [GlobeActions.MORPH_GLOBE_FINISHED]: morphGlobeFinished,

  [GlobeActions.FLY_TO_REQUEST]: flyToRequested,
  [GlobeActions.FLY_TO_FINISHED]: flyToFinished,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/globeReducer.js